export default __webpack_public_path__ + "static/media/breakout.c1611d2b.png";